/* Xundays sections: reveals, quick add, start-here picker, film controls */
(function () {
  'use strict';
  if (window.XD) return;

  var html = document.documentElement;
  html.classList.add('xd-js');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  /* ---------- Effect settings (from the Xundays tab bar, if present) ---------- */
  function config() {
    var el = document.getElementById('xd-config');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function applyEffects(c) {
    html.className = html.className.replace(/\bxd-(mo|ch|hl|st|cc)-\S+/g, '').replace(/\s+/g, ' ').trim();
    html.classList.add(
      'xd-mo-' + (c.motion || 'full'),
      'xd-ch-' + (c.character || 'wiggle'),
      'xd-hl-' + (c.headline || 'mask'),
      'xd-st-' + (c.stickers || 'hand'),
      'xd-cc-' + (c.cards || 'brand')
    );
  }

  function motionOff() {
    return reduce || html.classList.contains('xd-mo-off') || !('IntersectionObserver' in window);
  }

  /* ---------- Scroll reveals (also fire when a tab shows its sections) ---------- */
  function reveal(scope, replay) {
    var els = (scope || document).querySelectorAll('.xd-rv, .xd-head');
    if (motionOff()) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    els.forEach(function (el) {
      if (replay) el.classList.remove('is-in');
      if (!el.classList.contains('is-in')) io.observe(el);
    });
  }

  /* ---------- Cart: quick add + free shipping bar ---------- */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function setAdded(form, on) {
    var b = form.querySelector('button');
    var l = form.querySelector('[data-xd-label]');
    if (!b || !l) return;
    if (!l.hasAttribute('data-xd-default')) l.setAttribute('data-xd-default', l.textContent);
    b.classList.toggle('is-added', on);
    l.textContent = on ? (form.getAttribute('data-xd-added') || 'In your bag') : l.getAttribute('data-xd-default');
  }

  function syncCart(cart) {
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    document.querySelectorAll('[data-xd-ship]').forEach(function (el) {
      var goal = Math.round(parseFloat(el.getAttribute('data-xd-ship')) * rate);
      var left = Math.max(0, goal - cart.total_price);
      var msg = el.querySelector('[data-xd-ship-msg]');
      var fill = el.querySelector('[data-xd-ship-fill]');
      if (msg) {
        msg.textContent = left > 0
          ? (el.getAttribute('data-xd-ship-left') || '').replace('[amount]', money(left))
          : el.getAttribute('data-xd-ship-done');
      }
      if (fill) fill.style.width = Math.min(100, goal ? (cart.total_price / goal) * 100 : 100) + '%';
    });
    var ids = cart.items.map(function (i) { return String(i.variant_id); });
    document.querySelectorAll('[data-xd-add-form]').forEach(function (f) {
      setAdded(f, ids.indexOf(f.getAttribute('data-xd-variant')) > -1);
    });
  }

  function loadCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncCart(cart); return cart; });
  }

  function openCart() {
    if (window.theme && window.theme.hasCartDrawer) {
      document.dispatchEvent(new CustomEvent('theme:cart:toggle', { bubbles: true }));
    } else {
      window.location.href = ROOT + 'cart';
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-xd-add-form]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var b = f.querySelector('button');
    // A second tap on "In your bag" opens the cart
    if (b.classList.contains('is-added')) { openCart(); return; }
    b.setAttribute('aria-busy', 'true');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(f.getAttribute('data-xd-variant')), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        // Broadcast: refreshes the cart drawer, header count and its free-shipping bar
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        return loadCart();
      })
      .catch(function (err) {
        var l = f.querySelector('[data-xd-label]');
        if (l) l.textContent = (err && err.description) || 'Try again';
      })
      .then(function () { b.removeAttribute('aria-busy'); });
  });

  /* ---------- Start here picker + film button ---------- */
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-xd-pick]');
    if (p) {
      var wrap = p.closest('[data-xd-starter]');
      wrap.querySelectorAll('[data-xd-pick]').forEach(function (b) { b.setAttribute('aria-pressed', b === p ? 'true' : 'false'); });
      wrap.querySelectorAll('[data-xd-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-xd-panel') !== p.getAttribute('data-xd-pick');
        if (!panel.hidden) reveal(panel, true);
      });
      return;
    }
    var t = e.target.closest('[data-xd-film-toggle]');
    if (t) {
      var v = t.closest('[data-xd-film]').querySelector('video');
      if (v) { if (v.paused) { v.play(); } else { v.pause(); } }
    }
  });

  function setupFilms() {
    document.querySelectorAll('[data-xd-film]').forEach(function (film) {
      var v = film.querySelector('video');
      var bar = film.querySelector('[data-xd-film-bar]');
      var btn = film.querySelector('[data-xd-film-toggle]');
      if (!v || v.__xd) return;
      v.__xd = true;
      function state() {
        film.classList.toggle('is-paused', v.paused);
        if (btn) btn.setAttribute('aria-label', v.paused ? 'Play film' : 'Pause film');
      }
      v.addEventListener('play', state);
      v.addEventListener('pause', state);
      v.addEventListener('timeupdate', function () {
        if (bar && v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')';
      });
      if (motionOff()) v.pause();
      state();
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    applyEffects(config());
    reveal(document);
    setupFilms();
    if (document.querySelector('[data-xd-add-form], [data-xd-ship]')) loadCart().catch(function () {});
  }

  window.XD = { init: init, reveal: reveal };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-run when sections are added, edited or moved
  ['shopify:section:load', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(init, 0); });
  });
})();
